import { useNavigate } from 'react-router-dom'
import { User, LogOut, Globe, Bell, Info, ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { MTopbar } from '../MobileLayout'

function Row({ icon, label, value, onClick }: { icon: React.ReactNode; label: string; value?: string; onClick?: () => void }) {
  return (
    <button className="m-exam-card" style={{ padding: 14 }} onClick={onClick}>
      <div className="m-exam-card__icon" style={{ width: 38, height: 38 }}>{icon}</div>
      <div className="m-exam-card__body">
        <div className="m-exam-card__title" style={{ fontSize: '0.92rem' }}>{label}</div>
      </div>
      {value && <span style={{ color: 'var(--m-text-muted)', fontSize: '0.86rem' }}>{value}</span>}
      <ChevronRight size={18} color="var(--m-text-faint)" />
    </button>
  )
}

export default function MProfile() {
  const navigate = useNavigate()
  const { t } = useTranslation('pages')
  return (
    <>
      <MTopbar title={t('mobile.profile.title')} />
      <div className="m-scroll">
        <div className="m-page">
          <div className="m-card m-card--pad" style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
            <div
              style={{
                width: 56, height: 56, borderRadius: '50%', display: 'grid', placeItems: 'center',
                background: 'var(--m-primary-soft)', color: 'var(--m-primary)',
              }}
            >
              <User size={26} />
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: '1.05rem', color: 'var(--m-ink)' }}>Mehmet Demir</div>
              <div style={{ fontSize: '0.84rem', color: 'var(--m-text-muted)' }}>Öğretmen · Yıldız Koleji</div>
            </div>
          </div>

          <div className="m-section-title">{t('mobile.profile.settingsSection')}</div>
          <div className="m-stack m-stack--sm">
            <Row icon={<Globe size={18} />} label={t('mobile.profile.feedbackLangLabel')} value="Türkçe" />
            <Row icon={<Bell size={18} />} label={t('mobile.profile.notificationsLabel')} />
            <Row icon={<Info size={18} />} label={t('mobile.profile.aboutLabel')} value="v0.1.0" />
          </div>

          <div style={{ marginTop: 24 }}>
            <button className="m-btn m-btn--ghost m-btn--block" style={{ color: 'var(--m-danger)' }} onClick={() => navigate('/')}>
              <LogOut size={18} /> {t('mobile.profile.logout')}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
